"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);

    // Handle specific chunk loading errors that might affect SEO
    if (
      error.message?.includes("ChunkLoadError") ||
      error.message?.includes("Loading chunk") ||
      error.message?.includes("failed")
    ) {
      // For chunk loading errors, try to reload the page once
      const hasReloaded = sessionStorage.getItem("chunk-error-reload");
      if (!hasReloaded) {
        sessionStorage.setItem("chunk-error-reload", "true");
        window.location.reload();
        return;
      } else {
        // Clear the flag after successful reload attempt
        sessionStorage.removeItem("chunk-error-reload");
      }
    }
  }, [error]);

  // Don't render anything for certain errors that might be picked up by crawlers
  if (
    error.message?.includes("ChunkLoadError") ||
    error.message?.includes("Loading chunk")
  ) {
    return (
      <div className='w-full min-h-56 text-lg flex items-center justify-center flex-col'>
        <h2>Loading...</h2>
        <p className='text-sm text-muted-foreground mt-2'>
          Please wait while we load the page
        </p>
      </div>
    );
  }

  return (
    <div className='w-full min-h-56 text-lg flex items-center justify-center flex-col'>
      <h2>Something went wrong</h2>
      <p className='text-sm text-muted-foreground mt-2 mb-4'>
        We apologize for the inconvenience
      </p>
      <Button
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        Try again
      </Button>
    </div>
  );
}
